<template>
  <div id="indexlayout">
    <div id="indexlayout-right" :class="{ 'fiexd-header': siteFiexdHeader }">
      <div class="indexlayout-right-main">
        <app-main />
      </div>
    </div>
  </div>
</template>
<script>
import AppMain from '../components/AppMain'
// import ThemePicker from '../components/ThemePicker'

export default {
  name: 'LayoutIndex',
  components: { AppMain },
  mounted() {},
  computed: {
    isAdmin() {
      let role = this.$store.getters.role
      return role && role.id === 1
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/variables.scss';
#indexlayout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
#indexlayout-right {
  position: relative;
  flex: 1;
  overflow: auto;
  background-color: $mainBgColor;
  &.fiexd-header {
    display: flex;
    flex-direction: column;
    .indexlayout-right-main {
      flex: 1;
      overflow: auto;
    }
  }
}
</style>
